import styled from "styled-components"
import StatOverview from "../components/StatOverview"
import FloodVictims6 from "../assets/images/flood-victims-6.jpg"
import FloodVictims3 from "../assets/images/flood-victims-3.jpg"
import FloodVictims4 from "../assets/images/flood-victims-4.jpg"
import { phoneWidth } from "../Globalstyle"

const StyledSylhetSituation = styled.div`
  background-color: var(--tan);
`

const Info = styled.div`
  padding: var(--side-padding);
`

const Header = styled.div`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
`

const Details = styled.div`
  margin-bottom: 2rem;
  width: 70%;

  @media (max-width: ${phoneWidth}) {
    width: 100%;
  }
`

const StatsRow = styled.div`
  margin-bottom: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${phoneWidth}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`

const ImageContainer = styled.div`
  height: 25rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: ${phoneWidth}) {
    display: flex;
    flex-direction: column;
    height: auto;
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const SylhetSituation = () => {
  return (
    <StyledSylhetSituation>
      <Info>
        <Header>The Situation in Sylhet</Header>
        <Details>
          Due to torrential rainfall, more than 72% of Sylhet division 
          is now under water. This unexpected flash flood have impacted more 
          than 4.3 million people leaving many isolated, while others have sought 
          refuge in public spaces. With little access to food &amp; clean water, the survival 
          of these people are at stake.
        </Details>
        <StatsRow>
          <StatOverview
            highlight="4.3M"
            bigtext="People"
            smalltext="Affected by the flood"
          />
          <StatOverview
            highlight="৳1.2B"
            bigtext="Lost"
            smalltext="In Livestock"
          />
          <StatOverview
            highlight="47%"
            bigtext="Croplands"
            smalltext="Drowned"
          />
        </StatsRow>
      </Info>
      <ImageContainer>
        <Image src={FloodVictims6} alt="Flood victims"/>
        <Image src={FloodVictims3} alt="Flood victims"/>
        <Image src={FloodVictims4} alt="Flood victims"/>
      </ImageContainer>
    </StyledSylhetSituation>
  )
}

export default SylhetSituation